var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.data.is_static === true &&
    _vm.$options.components[_vm.data.page_name] !== undefined
  )?_c(_vm.data.page_name,{tag:"component",attrs:{"variables":_vm.variables}}):(_vm.data.is_static === true)?_c('div',[_vm._v("Unknown static component")]):(_vm.data.is_static === false)?_c('DynamicPageManager',{attrs:{"data":_vm.data,"variables":_vm.variables,"language":_vm.dataLanguageCode}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }